<footer>
  <div [@animateFooter]>
    <ul class="footer-left-bar d-none d-md-block">
      <li>
        <a
          href="https://api.whatsapp.com/send/?phone=923355444333"
          target="_blank"
        >
          <i class="fab fa-whatsapp"></i>
        </a>
      </li>
      <li>
        <a href="https://www.facebook.com/malikabubakar8" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/malik.abubakar8/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </li>
      <li>
        <a href="https://github.com/Abubakar0" target="_blank">
          <i class="fab fa-github"></i>
        </a>
      </li>

      <li>
        <a href="https://www.linkedin.com/in/abubakar8/" target="_blank">
          <i class="fab fa-linkedin-in"></i>
        </a>
      </li>
    </ul>
    <div class="footer-right-bar d-none d-md-block">
      <a href="mailto:mabubakarinbox@gmail.com" target="_blank"
        >mabubakarinbox&#64;gmail.com
      </a>
    </div>
  </div>
</footer>
